import React from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";

const Input = (props) => {
  const { label, name, ...rest } = props;
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <Field
        id={name}
        name={name}
        {...rest}
        className="form-control"
        component={TextField}
      />
    </>
  );
};

export default Input;
